import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { M_TBG_CUSTOM_Schema } from './M_TBG_CUSTOM_Schema';
import useSaveMutation from '../../../../Hooks/apis/useSaveMutaion';
import useSearchMutaion from '../../../../Hooks/apis/useSearchMutaion';

/** TBM_CD 조회 SP_TBM_R1 */
export const useSearch1 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      M_TBG_CUSTOM_Schema.mapper.search1,
      context
    );
    return apiRequest('post', Global.urls.TBM.getTbmR1, params);
  }, successOptions);
};

/** 교육현황 조회 SP_TBM_STATUS_R1 */
export const useSearch2 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      M_TBG_CUSTOM_Schema.mapper.search2,
      context
    );
    return apiRequest('post', Global.urls.TBM.getTbmStatusR1, params);
  }, successOptions);
};

/** 교육현황 저장 SP_TBM_STATUS_U1 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_TBG_CUSTOM_Schema.mapper.save1);
    return apiRequest('post1', Global.urls.TBM.saveTbmStatusU1, payload);
  }, options);
};
